import { useCallback, useEffect, useState } from "react";
import { Rocket, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

// Admin: publish the current ECU Library as a Base Map release (users download it once, in bulk).
export function BasemapReleasePanel({ refreshKey, title = "Release Library", button = "Release Library" }) {
  const [st, setSt] = useState(null);
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setSt((await api.get("/library/release")).data); } catch { setSt(null); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const release = async () => {
    if (!window.confirm("Rilis Base Map versi baru ke semua user?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/library/release", { notes });
      setSt(data); setNotes("");
      toast.success(`Base Map v${data.version} dirilis`);
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal rilis"); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="basemap-release-panel" className={`rounded-xl border p-5 mb-8 ${st?.pending ? "border-amber-700/50 bg-amber-950/20" : "border-slate-800 bg-[#0c1017]"}`}>
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[220px]">
          <h2 className="font-head font-bold text-xl uppercase text-white flex items-center gap-2"><Rocket className="h-5 w-5 text-cyan-400" /> {title}</h2>
          <p className="text-xs text-slate-400 mt-1">
            Rilis semua Base Map + kode motor sekaligus ke seluruh user. User yang sudah punya versi lama hanya mengunduh entri baru/berubah — data lama tetap tersimpan di PC-nya.<br />
            Rilis saat ini: <b className="text-white font-mono">{st?.version ? `v${st.version}` : "belum ada"}</b>
            {st && <span className="text-slate-500"> · {st.current_count ?? 0} Base Map · {st.current_records ?? 0} kode motor (ECU Database)</span>}
            {st?.released_at && <span className="text-slate-500"> · {new Date(st.released_at).toLocaleString("id-ID")}</span>}
            {st?.pending && <span className="ml-2 text-amber-300 font-semibold">· ada perubahan belum dirilis</span>}
            {st && !st.pending && st.version && <span className="ml-2 text-emerald-300 font-semibold">· up to date</span>}
          </p>
        </div>
        <Input data-testid="basemap-release-notes" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Catatan rilis (opsional)"
          className="w-64 bg-[#121824] border-slate-700 text-slate-100 text-sm" />
        <Button data-testid="basemap-release-refresh" variant="ghost" onClick={load} className="text-slate-400 hover:text-white"><RefreshCw className="h-4 w-4" /></Button>
        <Button data-testid="basemap-release-btn" onClick={release} disabled={busy}
          className="bg-gradient-to-r from-cyan-400 to-teal-500 text-slate-950 font-bold">
          <Rocket className="h-4 w-4 mr-1.5" /> {busy ? "Merilis…" : button}
        </Button>
      </div>
    </div>
  );
}
